import React from 'react';
import PropTypes from 'prop-types';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import { formatNumber } from '../../utils';

const DailyFollowersChart = ({ data }) => (
  <>
    <LineChart
      width={500}
      height={300}
      data={formatNumber(data)}
      margin={{
        top: 25,
        right: 30,
        left: 20,
        bottom: 25,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" width={1} />
      <YAxis />
      <Tooltip />
      <Legend verticalAlign="top" align="right" />
      <Line dataKey="instagram" stroke="violet" />
      <Line dataKey="facebook" stroke="blue" />
      <Line dataKey="total" stroke="green" />
    </LineChart>
  </>
);

DailyFollowersChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      facebook: PropTypes.number,
      instagram: PropTypes.number,
      total: PropTypes.number,
    })
  ),
};

export default DailyFollowersChart;
